module.exports = __webpack_public_path__ + "static/media/fast-sportBg.4d8511f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/fast-sport/fast-sportBg.png
// module id = 900
// module chunks = 7